import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { otherIssues } from '../../../constants/formFields/otherIssues';

export const StepSeven = () => {
  return (
    <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step">
      {/* <h6 className="text-lg font-bold mb-6">Discrimination issues</h6> */}

      <div className="mb-6 form-radio2-main">
        <p>
          <strong>Discrimination issues *</strong>
          <span>Select all that apply</span>
        </p>
        <div className="space-y-2">
          {otherIssues?.map((ele, i) => {
            const id = `other_issues_${i}`;
            return (
              <div className="flex items-center form-check2" key={i}>
                <Field
                  id={id}
                  type="checkbox"
                  name="other_issues"
                  value={ele?.value}
                  className="mr-2"
                />
                <label htmlFor={id}>{ele?.label}</label>
              </div>
            );
          })}
          <ErrorMessage name="other_issues" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
